import React from "react"

const RecomendedCourses = () => (
 <section class="lrws-section-2">
    <div class="container">
      <h3>Recommended Courses for IELTS Academic</h3>
      <div class="row">
        <div class="col-md-4">
          <div class="lrws-section-2-img-wrapper">
            <img src={require('../../images/ielts-academic.png')} alt="" />
          </div>
        </div>
        <div class="col-md-8">
          <div class="lrws-section-2-content-wrapper">
            <h4 class="lrws-section-2-title">Kanan IELTS Academic</h4>
            <p class="lrws-section-2-description">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae.</p>
            <ul>
              <li>DIAGNOSTIC TEST</li>
              <li>CONCEPT BUILDERS</li>
              <li>LIVE WEBINARS</li>
              <li>E-MENTORING</li>
              <li>VIDEO LESSONS</li>
              <li>MOCK TESTS</li>
              <li>SIMULATED TESTING</li>
              <li>SUPPORT</li>
            </ul>
            <button class="enroll-btn">ENROLL</button>
          </div>
        </div>
      </div>
    </div>
  </section>     
)

export default RecomendedCourses
